/**
 * VinylNeedle — decorative tonearm/needle element.
 * Positioned top-right of a vinyl, drops into playing position.
 */

interface VinylNeedleProps {
  playing: boolean;
  size?: number;
}

export default function VinylNeedle({ playing, size = 320 }: VinylNeedleProps) {
  const armLength = size * 0.52;
  const pivotX = size * 0.88;
  const pivotY = size * 0.04;

  return (
    <div
      className="absolute pointer-events-none"
      style={{
        top: 0,
        right: 0,
        width: size * 0.5,
        height: size * 0.8,
        transformOrigin: `${pivotX}px ${pivotY}px`,
        transform: playing ? "rotate(-6deg)" : "rotate(-28deg)",
        transition: playing
          ? "transform 0.9s cubic-bezier(0.34,1.3,0.64,1)"
          : "transform 0.6s cubic-bezier(0.4,0,0.2,1)",
      }}
    >
      <svg
        width={size * 0.5}
        height={size * 0.8}
        viewBox={`0 0 ${size * 0.5} ${size * 0.8}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Pivot dot */}
        <circle
          cx={pivotX}
          cy={pivotY}
          r={size * 0.018}
          fill="hsl(0 0% 22%)"
          stroke="hsl(0 0% 30%)"
          strokeWidth="1"
        />
        {/* Tonearm body */}
        <line
          x1={pivotX}
          y1={pivotY + size * 0.022}
          x2={size * 0.12}
          y2={armLength * 0.85}
          stroke="hsl(0 0% 28%)"
          strokeWidth={size * 0.012}
          strokeLinecap="round"
        />
        {/* Cartridge head */}
        <rect
          x={size * 0.06}
          y={armLength * 0.82}
          width={size * 0.1}
          height={size * 0.04}
          rx="1"
          fill="hsl(0 0% 20%)"
          stroke="hsl(0 0% 30%)"
          strokeWidth="0.8"
          transform={`rotate(-18, ${size * 0.11}, ${armLength * 0.84})`}
        />
        {/* Stylus needle */}
        <line
          x1={size * 0.075}
          y1={armLength * 0.86}
          x2={size * 0.065}
          y2={armLength * 0.95}
          stroke="hsl(40 20% 60%)"
          strokeWidth="0.8"
          transform={`rotate(-18, ${size * 0.11}, ${armLength * 0.84})`}
        />
      </svg>
    </div>
  );
}
